var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMobileBgTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 183,
    viewBox: "0 0 414 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.88 -74.1978L150.401 -52.6881C183.42 -20.265 228.684 -0.256943 278.63 -0.256943C328.184 -0.256943 373.13 -19.9535 406.079 -51.9294L406.111 -51.9423L226.917 127.157L226.928 127.127C193.676 161.356 147.149 182.634 95.6417 182.634C45.1184 182.634 -0.622841 162.169 -33.7365 129.081L-33.7237 129.067L-54.1082 108.693C-104.5 58.3282 -104.659 -23.2784 -54.4656 -73.8406H-54.4642C-3.99239 -124.681 78.2092 -124.842 128.88 -74.1978Z",
    fill: "#FF544D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.268 -68.2067L458.009 -68.1953C418.076 -68.5325 378.254 -83.9177 347.797 -114.375C286.119 -52.6965 286.079 47.2651 347.708 108.894C378.518 139.704 418.908 155.101 459.306 155.088L459.306 155.073L484.179 155.062C545.662 155.038 595.591 105.303 595.857 43.8198L595.858 43.819C596.123 -18.0056 546.093 -68.2315 484.268 -68.2067Z",
    fill: "#FFBD00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMobileBgTop);
export default __webpack_public_path__ + "static/media/home-mobile-bg-top.a919871f.svg";
export { ForwardRef as ReactComponent };